export const CREATE_STUDENT = `
mutation CreateStudent($input: CreateStudentInput!) {
  createStudent(input: $input) {
    success,
    message,
    student {
      firstName,
      lastName,
      email,
      cellPhone,
      guardianName,
      courseType,
      classInterested,
      hasExperience,
      experienceDetails,
      dob,
      gender,
      street,
      city,
      state,
      zipcode,
      enrollDate,
    }
  }
}
`;
